import React, { Component } from "react";
import Collapsible from "react-collapsible";
import HttpServices from "../../../utils/Http.services";
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../../utils/useful";
import { diagramComponents, diagramGroups } from "../../../variables/diagramFunctions";
import FormViewer from "../../FormViewer";
import LoaderButton from "../../LoaderButton";
import SidebarView from "../../SidebarView";
import StagesManager from "../../StagesManager";
import TableViewer from "../../TableViewer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import FixedView from "../../FixedView";
import ReactLoaderSpinner from "react-loader-spinner";
import ButtonAnimated from "../../buttons/ButtonAnimated";
import RemoveConfirmationModal from "../../../modals/RemoveConfirmationModal";

class DiagramVariablesSidebar extends Component {

    state = {
        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}variable.name', required: false }, showMain: true },
            { key: 'dataType', type: 'TextInput', col: '12', information: { label: '{{lang}}Data type', placeholder: '{{lang}}Data type', required: false }, showMain: true },

            // { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: true }, showMain: true },
        ],

        actions: {
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: '/assets/icons/useful/edit.png' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', function: "openRemoveModal", icon: '/assets/icons/useful/trash.png' },
        },

        varHeader: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}name', placeholder: '{{lang}}Variable name', required: true } },
            { key: 'dataType', type: 'SelectInput', col: '12', information: { label: '{{lang}}Data type', placeholder: '{{lang}}Select ...', type: 'local', items: [{ title: '{{lang}}String', value: 'String' }, { title: '{{lang}}Number', value: 'Number' }, { title: '{{lang}}Date', value: 'Date' }, { title: 'Record', value: '{{lang}}Record' }, { title: 'Boolean', value: 'Boolean' }, { title: 'Object', value: '{{lang}}Object' }, { title: 'ListOfRecords', value: 'List of records' }, { title: 'User', value: 'User' }], required: true } },
            // { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}type', placeholder: '{{lang}}type', type: 'local', items: [{ title: 'hub', value: 'hub' }, { title: 'global', value: 'global' }, { title: 'applet', value: 'applet' }, { title: 'frame', value: 'frame' }, { title: 'record', value: 'record' }, { title: 'temp', value: 'temp' },], required: true } },
            // {
            //     key: 'frame', type: 'SelectInput', col: '12', information: { label: '{{lang}}frame', type: 'api', address: 'getFrames', filter: { applet: '{{appletId}}' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}frame', required: false }, showMain: false,
            //     dependencies: [{
            //         refKey: 'type',
            //         targetKey: 'frame',
            //         conditions: {
            //             root: {
            //                 id: 'root',
            //                 action: 'or',
            //                 conditions: {
            //                     1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'frame' } },
            //                 }
            //             },
            //         },
            //         show: true,
            //         init: true,
            //     }],
            // },
            {
                key: 'value', type: 'DynamicInput', col: '12', information: { label: '{{lang}}Value', helperField: 'field', placeholder: '{{lang}}Value', required: false, },
                dependencies: [{
                    refKey: 'dataType', targetKey: 'value',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.dataType' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeHeader: [{ key: 'information.inputType', value: '@data.dataType' }] }
                    }],
                    else: { show: false, },
                    init: true,

                }],
                showMain: true
                // dependencies: [{
                //     refKey: 'type',
                //     targetKey: 'value',
                //     conditions: {
                //         root: {
                //             id: 'root',
                //             action: 'or',
                //             conditions: {
                //                 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'applet' } },
                //                 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'hub' } },
                //                 2: { id: 2, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'global' } }
                //             }
                //         },
                //     },
                //     show: true,
                //     init: true,
                // }],
            },

        ],
    }

    componentDidMount() {
    }

    openFirstView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {
            if (this.state.fixed == true) {
                this.firstView.hideView()
            } else {
                this.firstView.showView()
            }
        })
    }





    open = (key) => {
        this.varSidebarView.open()
        setTimeout(() => {

            this.tableViewer.calcResize()

        }, 300);
    }

    showChildsList = (parent) => {
        if (parent) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: parent })
        } else {
            this.subSidebarView.closeSidebar()
            setTimeout(() => {
                this.setState({ selectedParent: parent })
            }, 500);
        }
    }

    showApplet = (applet) => {
        if (applet) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: applet })
        }
    }

    openVariables = () => {
        this.varSidebarView.open()
        this.openFirstView()
    }

    addNewVariables = () => {
        this.setState({ currentVariable: null, currentVariableIndex: null }, () => {
            this.stageManager.changeStage('addNew')
        })
    }

    backStage = (stage) => {
        this.stageManager.changeStage(stage)
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'DiagramEditor') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    saveVariables = () => {
        let data = this.form.getForm() ?? {}
        data.applet = this.props.variables.appletId
        data.appletHub = this.props.variables.appletHub._id ?? this.props.variables.appletHub
        data.hub = this.props.variables.appletHub._id ?? this.props.variables.appletHub

        // if (data.type) {
        HttpServices.request('postVariables', data, (fetchResult, fetchError) => {
            if (fetchError) {

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })

            let variablesList = this.props.variablesList ?? []

            if (data._id) {

                variablesList[this.state.currentVariableIndex] = fetchResult.info

            } else {
                variablesList.push(fetchResult.info)
            }
            this.setData('variablesList', variablesList, 'DiagramEditor', () => {
                this.backStage('main')
            })
        })
        // }
    }




    onClick = (cprop) => {
        if (cprop.isParent) {
            this.showChildsList(cprop)
        } else {
            if (!this.props.draggable) {
                this.props.onClick(cprop, this.state.selectedParent?.type)
            }
        }
    }

    functionsHandler = (type, name, data, extra, cb) => {

        this.setState({ currentVariable: data, currentVariableIndex: extra.index }, () => {

            if (this[name]) {
                this[name](data, extra, cb)
            }

        })


    }

    openEditModal = () => {

        this.stageManager.changeStage('addNew')

    }

    openRemoveModal = (prop, extra) => {
        this.removeModal.modal.showModal()
    }

    fetchRemove = () => {


        this.setState({ isLoadingRemove: true })
        let id = this.state.currentVariable._id
        let body = { id: id }

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        HttpServices.request('removeVariable', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let variablesList = this.props.variablesList ?? []

            // let data = JSON.parse(JSON.stringify(this.state.data))
            variablesList.splice(this.state.currentVariableIndex, 1)

            // console.log(variablesList)
            this.setData('variablesList', variablesList, 'DiagramEditor', () => {
                this.stageManager.changeStage('')
                setTimeout(() => {
                    this.stageManager.changeStage('main')
                }, 10);

            })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })



    }


    render() {

        return (
            <>

                <SidebarView width={this.props.width} ref={el => this.varSidebarView = el} sideOpen={false} hideOverlay={false} paddingTop={'0px'} left={50} widthCondition={{ xs: "90%", sm: '80%', md: '350px', lg: "350px", xl: "350px" }}>
                    <StagesManager ref={el => this.stageManager = el} fast={true} >
                        <div className="" stageName={'main'} stage={0}>
                            {/* <div className="flexcb mb-2 pt-1 ">
                                <p className="text-normal text-semibold">{translate("Variables")}</p>
                                <div style={{ cursor: 'pointer' }} onClick={() => this.addNewVariables()}>
                                    <p className="text-smaller" style={{ color: '#0c53cc' }}>+ Add New</p>
                                </div>
                            </div> */}

                            <div className="flexcb  py-1 w-100 px-2" style={{ position: 'sticky', top: 0, zIndex: 2, borderBottom: '1px solid #eee', backgroundColor: '#fff' }}>
                                <div className="flexc w-80  py-1 ">

                                    <p className="text-bold text-normal px-1">{translate("Shared variables")}</p>

                                </div>
                                <div className=" mld-2">
                                    <div className='flexc'>
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={this.addNewVariables}
                                            title={checkTranslation('Add new')}
                                            icon='/assets/icons/angle-right-white2.svg'
                                            textColor={this.props.colors?.textColor ?? '#000'}
                                            // invert={!this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background}
                                        // isLoading={this.state[prop.loader]}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <TableViewer
                                    data={this.props.variablesList}
                                    headers={this.state.varHeader}
                                    width={this.state.width}
                                    actions={this.state.actions}
                                    ref={e => this.tableViewer = e}
                                    functionsHandler={this.functionsHandler}
                                />

                            </div>
                        </div>


                        <div className=" px-0" stageName={'addNew'} stage={1}>
                            {/* <div className="flexcb mb-2 px-2 pb-1 pt-1" style={{ borderBottom: '1px solid #eee' }}>
                                <div className="flexcc ">
                                    <button className='flexc' onClick={() => this.backStage('main')}>
                                        <img width={20} className='invert' src="/assets/icons/back-white.svg" />
                                    </button>
                                    <p className="text-small text-semibold">{translate("Add Variable")}</p>
                                </div>
                                <button className="blue-btn br-8 p-1 px-2" onClick={() => this.saveVariables()}>
                                    <p>submit</p>
                                </button>
                            </div> */}

                            <div className="flexcb  py-1 w-100 px-2" style={{ position: 'sticky', top: 0, zIndex: 2, borderBottom: '1px solid #eee', backgroundColor: '#fff' }}>
                                <div className="flexc w-80  py-1 " onClick={() => this.stageManager.changeStage('main')}>
                                    <button className="flexcc  px-1">
                                        <img className="rotate-0" src="/assets/icons/useful/fi-sr-angle-left.png" height={14} alt="" />
                                    </button>
                                    <p className="text-bold text-normal px-1">{translate("Add Variable")}</p>

                                </div>
                                <div className=" mld-2">
                                    <div className='flexc'>
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={this.saveVariables}
                                            title={checkTranslation('Submit')}
                                            icon='/assets/icons/angle-right-white2.svg'
                                            textColor={this.props.colors?.textColor ?? '#000'}
                                            // invert={!this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background}
                                        // isLoading={this.state[prop.loader]}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="pt-2">
                                <FormViewer ref={el => this.form = el} headers={this.state.varHeader} initData={this.state.currentVariable} formClass="bordered-form" inputClass={'bordered-input'} />
                            </div>
                        </div>
                    </StagesManager>



                    <RemoveConfirmationModal
                        isLoading={this.state.isLoadingRemove}
                        confirmed={this.fetchRemove}
                        ref={el => this.removeModal = el}
                    />


                </SidebarView>

            </ >
        )

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(DiagramVariablesSidebar);